import React from "react";
import { skillsSection } from "../../portfolio";
import "./SoftwareSkill.scss"; // Ensure this matches your file name

const SoftwareSkill = () => {
  return (
    <ul className="dev-icons">
      {skillsSection.softwareSkills.map((skill, index) => (
        <li key={index} className="software-skill-inline">
          {React.isValidElement(skill.icon) ? (
            <skill.icon size={40} /> // For react-icons components
          ) : (
            <skill.icon width={40} height={48} /> // For custom SVG components
          )}
          <p>{skill.skillName}</p>
        </li>
      ))}
    </ul>
  );
};

export default SoftwareSkill;
